import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Flex } from 'antd';
import { setHeroTitle, setHeroContent, setHeroImage } from '../redux/hero.slice'

import Conatiner from '../shared/Conatiner/Container';

import useMobileCheck from '../mobile';

const ToursPage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setHeroImage(false));
    dispatch(setHeroTitle(`User Guides`))
    dispatch(setHeroContent(`Our user interfaces are simple and easy to use, yet if you want to get a preview of some of the features available before you sign up then the following guides may help.`))
  }, [dispatch]);

  const containerStyle = {
    background: 'white',
    borderRadius: '16px',
    marginLeft: '10px',
    padding: '10px',
    height: '100%'
  }

  const { isMobile } = useMobileCheck();

  return (
    <Flex vertical
      style={{
        paddingTop: 20,
        paddingBottom: 20
      }}
      gap={20}>
      <Conatiner
        style={containerStyle}
        colour="white">
        <div 
        style={{ 
          position: "relative", 
          boxSizing: "content-box", 
          aspectRatio: "1.7777777777777777",
          maxHeight: "80vh", 
          tmpomaxHeight: "80svh",
          width: "100%", 
          padding: "40px 0 40px 0"
        }}>
          <iframe 
            data-version="2" 
            src="https://app.supademo.com/showcase/embed/cmfks6164083yys0i3my9t1mp?embed_v=2&utm_source=embed" 
            loading="lazy" 
            title="ShuttleOps" 
            allow="clipboard-write" 
            frameborder="0" 
            webkitallowfullscreen="true" 
            mozallowfullscreen="true" 
            allowfullscreen 
            style={{
              width: "100%", 
              height: "100%"
            }}>
          </iframe>
        </div>
      </Conatiner>
    </Flex>
  )
}

export default ToursPage;